<template>
  <section>
    <LoadingSpinner v-if="loading" />
    <div v-else class="mx-2">
      <div class="col-md-12 w-100 my-2 card p-2">
    
        <!-- Renderizo lista de emails configurados para enviar por smtp -->
        <div class="mx-0 px-0 table-responsive">
          <Table
            v-if="!loading"
            class="mx-2 w-100"
            :headers="headers"
            :cols="cols"
            :data="emails"
            :model="model"
            :checkbox="false"
            :notselect="true"
            @openClient="openClient"
            @runConfigSmtp="runConfigSmtp">
          </Table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { monitorService, emailsService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { set } from "core-js/core/dict";

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),
  },

  data() {
    return {
      loading: true,
      emails: [],
      model: {},
      cols: [
        [
          {
            value: "task_open_hours",
            type: 'time',
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            // class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ],
        [
          {
            value: "email",
          },
        ],
        [
          // Config SMTP
          {
            value: "config_smtp_status",
            btnId: "user_id",
            type: "btnAction",
            name: "Config SMTP",
            disabled:['1', '2'], //Valores con lo que el boton se mostrara deshabilitado.
            loading_data:['2'], //valores con lo que el boton mostrara como Loading...
            emit:"runConfigSmtp",
          },
        ],
      ],
      headers: [
        {
          label: 'Time',
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: this.$t("lang.column.client"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: "Email", //this.$t("Email"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "AgencyBilling",
          id: 1,
        },
        {
          label: 'Action',
          percentage: "10.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 1,
        },
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
    };
  },
  components: {
    Table,
    LoadingSpinner,
  },

  mounted() {
    this.loadData();
    this.setCurrentRouteChild({ child: "" });
  },

  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    loadData() {
      monitorService.getEmailsConfigSmtp('22')
      .then((res) => {
        const { result } = res;
        if (result) {
          this.emails = res.result;
          this.loading = false;
        }
      });
    },

    runConfigSmtp(value){
      this.emails = this.emails.map(item => {
        return {
          ...item,
          config_smtp_status: item.user_id == value ? '2' : item.config_smtp_status
        }
      })

      emailsService.updateSmtpStatus(value)
        .then( result => {

          if (result.result == 'ok') {
              this.emails = this.emails.map(item => {
              return {
                ...item,
                action_ok: item.user_id == value ? 'yes' : item.action_ok,
                config_smtp_status: item.user_id == value ? '1' : item.config_smtp_status,
              }
            })

            this.$emit('updateConfigSmtpTotal')

          } else {
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.not_campaign_active"),
              text: "",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33a2c",
              confirmButtonText: "Ok",
            })
          }
        })
        .catch(error => {
          console.log('error', error)
        });
    },

    filter(event) {
      this.filters = event;
      this.loadData(this.orderStatus, this.filters);
    },

    openClient(client_id) {
      //"client_id", client_id);
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.banner {
  border-radius: 25em !important;
  color: #fff;
  font-size: 0.75em;
  text-align: left;
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 0.2em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  background-color: #4d4deb;
  width: 98%;
}

.banner-message {
  margin-left: 2em;
  margin-right: 2em;
}
</style>
